import React from 'react'
import { connect } from 'react-redux'
import { ApiProvider, Project, ResourceUsers } from '@leverege/api-redux'
import { ResourceUsersScreen } from '@leverege/api-ui-user-management'

class ProjectUsersScreen extends React.Component {

  static contextType = ApiProvider.Context

  render() {
    const { match : { params } } = this.props
    const { projectId } = params

    const originalApi = this.context

    const actions = Project( projectId )
    actions.users = () => {
      return new ResourceUsers( {
        resourceId : projectId,
        resourceApi : getProjectApi
      } )
    }

    return (
      <ResourceUsersScreen
        allowApiAccess
        selectorProps={{ simple : false }} 
        projectId={projectId} 
        resourceId={projectId} 
        actions={actions}
        api={{ ...originalApi, project : () => getProjectApi( null, null, { api : originalApi }, projectId ) }} />
    )
  }
}

function getProjectApi( dispatch, getState, opts, resourceId ) {
  const {
    api
  } = opts;
  const r = api.project( resourceId )
  const originalAccounts = r.accounts.bind( r )
  r.accounts = ( ...args ) => {
    const resolved = originalAccounts( ...args )
    return {
      ...resolved,
      async list( opts ) {
        if ( opts?.username || opts?.email ) {
          const rootRes = await api.users().list( opts )
          const projectRes = await resolved.list( opts )
          return {
            total : rootRes.total + projectRes.total,
            count : rootRes.count + projectRes.count,
            limit : rootRes.limit,
            offset : rootRes.offset,
            items : [ ...rootRes.items, ...projectRes.items ]
          }
        } 
        return resolved.list( opts )
      }
    }
  }

  const originalUsers = r.users.bind( r )
  r.users = ( ...args ) => {
    const resolved = originalUsers( ...args )
    return {
      ...resolved,
      add : async ( body, opts ) => {
        if ( opts?.test || !body.userId ) {
          return resolved.add( body, opts )
        }
        
        try {
          await r.members().add( body.userId, { role : 'user' } )
        } catch ( e ) {
          // ignore
        }

        return resolved.add( body, opts )
      },
      remove : async ( body, opts ) => {
        const failed = []
        if ( Array.isArray( body?.userId ) ) {
          for ( let i = 0; i < body.userId.length; i++ ) {
            try {
              await r.members().remove( body.userId[i] )
            } catch ( e ) {
              failed.push( body.userId[i] )
            }
          }
        }
        if ( failed.length > 0 ) {
          return resolved.remove( { ...body, userId : failed }, opts )
        }

        return {}
      }
    }
  }
  return r;
}

export default connect(
  ( state, props ) => ( {
  } )
)( ProjectUsersScreen );
